import React, { FC, PropsWithChildren } from 'react';
import { Box, BoxProps, HTMLChakraProps, chakra } from '@chakra-ui/react';

const DEFAULT_ID = 'foundry-skip-nav';

interface Props extends Omit<HTMLChakraProps<'a'>, 'children'> {
  text: string;
  /** id of the content target the link points to (renders `href="#${contentId}"`) */
  contentId?: string;
}

const Link: FC<Props> = ({ text, contentId = DEFAULT_ID, ...rest }) => {
  /**
   * DOM
   */
  return (
    <chakra.a
      href={`#${contentId}`}
      data-object-type="skip-nav-link"
      css={{
        userSelect: 'none',
        border: 0,
        height: '1px',
        width: '1px',
        margin: '-1px',
        padding: 0,
        outline: 0,
        overflow: 'hidden',
        position: 'absolute',
        clip: 'rect(0 0 0 0)',
      }}
      _focus={{
        clip: 'auto',
        width: 'auto',
        height: 'auto',
        position: 'fixed',
        top: '1.5rem',
        insetStart: '1.5rem',
        padding: '1rem',
        bg: 'white',
        boxShadow: 'base',
        textDecoration: 'underline',
      }}
      {...rest}
    >
      {text}
    </chakra.a>
  );
};

interface ContentProps extends Omit<BoxProps, 'id'> {
  id?: string;
}

const Content: FC<PropsWithChildren<ContentProps>> = ({ children, id = DEFAULT_ID, ...rest }) => {
  /**
   * DOM
   */
  return (
    <Box id={id} tabIndex={-1} outline={0} data-object-type="skip-nav-content" {...rest}>
      {children}
    </Box>
  );
};

export const SkipNav = {
  Link,
  Content,
};
